<template>
  <n-layout>
    <n-layout-header class="relative z-1">
      <Header />
    </n-layout-header>
    <n-layout-content
      content-style="height: calc(100vh - 64px); overflow-y: auto; display: flex; flex-direction: column;"
      content-class="scroll-container"
      data-scroll-container
    >
      <slot />
      <Footer v-if="route.name !== 'index'" style="margin-top: auto" />
    </n-layout-content>
    <ContactUs />
  </n-layout>
</template>

<script setup lang="ts">
const route = useRoute()
</script>

<style lang="scss">
.content {
  max-width: 1080px;
  margin-right: auto;
  margin-left: auto;
}
</style>
